import React, { useContext } from 'react';
import moment from 'moment';
import { ReactDatePicker } from '@mummssoftware/common-ui';
import { VisitsGlobalContext } from '@mummssoftware/global-context';
import { AppContext } from '../../context';
import {
  FilterHeader,
  FilterContainer,
  FilterSubHeader,
} from '../../components/layout/WrapperDiv';
import { SummaryFilterContext } from './SummaryFilters';
import { filterByDate, From, To } from '../../translations/en.json';

export const DateFilter = () => {
  const { patient } = useContext(AppContext);

  const { fromDate, toDate } = useContext(VisitsGlobalContext);
  const { tentativeFilters, updateTentFilters } = useContext(
    SummaryFilterContext,
  );

  const setFromDate = (date: any) => {
    updateTentFilters({ ...tentativeFilters, fromDate: date });
  };
  const setToDate = (date: any) => {
    updateTentFilters({ ...tentativeFilters, toDate: date });
  };

  const fromDateChanged =
    String(fromDate) !== String(tentativeFilters.fromDate);
  const toDateChanged = String(toDate) !== String(tentativeFilters.toDate);

  return (
    <FilterContainer>
      <FilterHeader selected={fromDateChanged || toDateChanged}>
        {filterByDate}
      </FilterHeader>
      {!patient && (
        <div style={{ display: 'flex', paddingTop: '5px' }}>
          <div style={{ display: 'flex' }}>
            <FilterSubHeader selected={fromDateChanged}>{From}</FilterSubHeader>
            <ReactDatePicker
              selectedDate={new Date(tentativeFilters.fromDate)}
              onChange={setFromDate}
              maximumDate={moment(tentativeFilters.toDate)
                .subtract(1, 'days')
                .toDate()}
              color={(fromDateChanged && 'secondary') || 'primary'}
            />
          </div>
          <div style={{ display: 'flex' }}>
            <FilterSubHeader selected={toDateChanged}>{To}</FilterSubHeader>
            <ReactDatePicker
              selectedDate={new Date(tentativeFilters.toDate)}
              onChange={setToDate}
              maximumDate={moment().toDate()}
              minimumDate={moment(tentativeFilters.fromDate)
                .add(1, 'days')
                .toDate()}
              color={(toDateChanged && 'secondary') || 'primary'}
            />
          </div>
        </div>
      )}
    </FilterContainer>
  );
};
